module.exports = require("./lib/_stream_duplex.js")



//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/readable-stream/duplex.js
// module id = ../../../../readable-stream/duplex.js
// module chunks = 3